/**
 * The ready body of the New contest dialog (ISSUE-1042 R2): the contest name,
 * the line saying whose rules were copied, the inline refusal banner, and the
 * create-pool wizard's rules step reused without Max members, which is a pool
 * setting and not part of a contest. Stateless.
 */
import { InlineBanner } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { CreatePoolRulesStep } from "../createPool/CreatePoolRulesStep";
import type { typeSurvivorRulesDraft } from "../createPool/survivorRulesDraft";
import { type typeNewContestDraft } from "./newContestModel";

export type typeNewContestFormProps = {
  draft: typeNewContestDraft;
  prefillNote: string | null;
  inlineNote: string | null;
  onChangeRules: (rules: typeSurvivorRulesDraft) => void;
};

export const NewContestForm = ({
  draft,
  prefillNote,
  inlineNote,
  onChangeRules,
}: typeNewContestFormProps): ReactNode => {
  return (
    <div className="flex flex-col gap-6" data-testid="new-contest-form">
      {inlineNote !== null ? (
        <div data-testid="new-contest-inline-note">
          <InlineBanner variant="warning" message={inlineNote} />
        </div>
      ) : null}
      <p className="text-caption text-ink-secondary">
        Your contest number is assigned automatically when it is created.
      </p>
      {prefillNote !== null ? (
        <p
          className="text-caption text-ink-secondary"
          data-testid="new-contest-prefill-note"
        >
          {prefillNote}
        </p>
      ) : null}
      <CreatePoolRulesStep
        rules={draft.rules}
        onChangeRules={onChangeRules}
        isMaxMembersShown={false}
      />
    </div>
  );
};
